import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    margin: '6%'
  },
  typographyLabel: {
    fontSize: theme.spacing(2),
    fontWeight: 'bold',
    color: theme.palette.text.primary
  },
  iconButton: {
    float: 'right'
  },
  textField: {
    width: '80%'
  },
  selectField: {
    width: '100%'
  },
  tabs: {
    backgroundColor: 'rgb(240,242,250)',
    width: '15%',
    padding: '10px'
  },
  tabPanel: {
    padding: '15px',
    width: '100%'
  },
  indicator: {
    left: 0
  },
  moduleBtn: {
    margin: '10px',
    width: '100%',
    padding: '25px',
    transition: 'borderLeft 1s ease-out',
    '&.active': {
      borderLeft: '3px solid #6b70d8',
      borderRadius: 0
    }
  }
}));

export default useStyles;
